// Core's manualDiscountTypes holds both kinds of manual pricing rule:
//   TD       — total bill
//   FD / PD  — line item (flat / percentage)
// Fashion has separate "Line discount" and "Bill discount" buttons, so the
// drawer is given only the rules for the button that opened it.
const LINE_TYPES = new Set(["FD", "PD"]);

export function scopeDiscountTypes(types, scope) {
  const list = Array.isArray(types) ? types : [];
  if (scope === "line") return list.filter((t) => LINE_TYPES.has(t?.type));
  if (scope === "bill") {
    const bill = list.filter((t) => t?.type === "TD");
    // A till with no bill-level rule keeps the old behaviour (all rules, where
    // a line rule asks which line to discount) rather than an empty drawer.
    return bill.length > 0 ? bill : list;
  }
  return list;
}
